import styled from 'styled-components';
import rmq from 'styled-rmq';

export default styled.div`
	font-size: 1.9rem;
	font-family: 'Lato', sans-serif;
	font-weight: 400;
	color: rgba(255, 255, 255, 0.8);
	line-height: 1.65;

	${rmq('t')} {
		padding-left: 1rem;
		padding-right: 1rem;
	}
	${rmq('ml')} {
		font-size: 1.6rem;
	}
`;
